// extracted by mini-css-extract-plugin
export default {"container":"N0-z","list":"O0-z"};